<template>
  <one-column-layout class="preview"
                     :loading="!loaded"
                     ref="page_scroll"
                     :content-styles="pageStyle">

    <template slot="loading-message">
      <p>Loading data. Hang tight!</p>
    </template>

    <div class="transition-height" :class="isScrolling ? 'minimize' : undefined" slot="titleBar">

      <patient-profile-header :mode="isScrolling ? 'small' : 'normal'"
                              @close="hidePreview"
                              @edit = "doEdit"
                              :patient="selectedPatient.info" >
        <template slot="actions" v-if="$mq.tablet__up">
          <smd-btn icon="smd-icon-fullscreen"  />
        </template>
        <template slot="bottomActions">
          <smd-btn bg icon="smd-icon-action-add" @click="createNewCase"/>
        </template>
      </patient-profile-header>
    </div>

    <div>
      <pogs-obstetric-history :patient="selectedPatient"/>
      <resize-observer @notify="handleResize" />
    </div>

  </one-column-layout>
</template>


<script>
  import PogsObstetricHistory from '../patients/pogs-patient-preview--obstetric-history'
  import PatientProfileHeader from '../patientprofile/patient-header'
  import {ACTION_LOAD_PATIENT_CASES, ACTION_LOAD_PATIENT_INFO} from "../../../store/modules/patients";
  import {mapGetters} from 'vuex'
  import {GETTER_SELECTED_PATIENT} from '../../../store/modules/patients'

  import Routes from '../../../router/route-constants'
  import scrollListener from '../../../mixins/scroll-listener'
  import uiHelper from '../../../mixins/uihelper'


  export default {
    name: "pogs-patient-preview",
    data() {
      return {
        loaded: false
      }
    },
    components: {
      PogsObstetricHistory, PatientProfileHeader
    },
    mixins: [scrollListener, uiHelper],
    computed: {
      ...mapGetters({
        selectedPatient: GETTER_SELECTED_PATIENT
      }),
      pageStyle(){
        return ['dark', 'border-top', 'space-l'];
      }
    },
    methods: {
      createNewCase(){
        this.toggleOverlay();
        this.$router.push({
          name: Routes.ROUTE_NEW_PATIENT_CASE,
          params:{patientid: this.selectedPatient.info._id}
        });
      },
      hidePreview() {
        this.togglePreview();
        this.$router.push('/patients');
      },
      init(patientid) {
        this.$store.dispatch(ACTION_LOAD_PATIENT_INFO, patientid).then( () => {
          this.$store.dispatch(ACTION_LOAD_PATIENT_CASES, patientid).then( () => {
            this.loaded = true
          })
        })
      },
      doEdit(){
        this.$router.push({
          name: Routes.ROUTE_EDIT_PATIENT,
          params:{patientid: this.selectedPatient.info._id}
        });
      }
    },
    beforeRouteEnter(to,from,next) {
      next( vm => {
        vm.init(to.params.patientid)
      })
    },
    beforeRouteUpdate(to,from,next) {
      this.loaded = false;
      this.init(to.params.patientid);
      next()
    }
  }
</script>

<style lang="scss">
  @import "../../../scaffolding/scss/pogs-util";

  .minify{

    .pogs-list__item{
      grid-template-columns: 40px 1fr 10px;
      align-items: flex-start !important;

      @include transition;

      &.active,
      &:hover{
        margin-right: -3px;
        margin-left: -3px;

        .patient-data__details{
          p{ font-size: 15px; }
        }
      }
    }

    .patient-data__details{
      p{ font-size: 13px; }
    }

    .patient-data__status{
      @include space-me($t: xs);
      max-width: 270px;
    }

  }

  .content--info{
    @extend %flex-row--center-xy;
    min-height: 280px;
    margin-top: -45px !important;

    label{
      font-style: italic;
      text-transform: none;
    }
  }

  .case{
    .pogs-list--panels{
      .pogs-list__item:last-child{
        margin-bottom: space(xl);
      }
    }

    .data-entry__row{
      margin-left: space(base);
    }

    .pogs-list--table{
      @include space-me($prop: margin, $t: s, $b: l, $r: xl);
      flex-wrap: wrap;
    }
  }

  .data-entry__row{
    @include make-grid-cols(1fr 2fr, space(m));
    @include space-me($t: m, $b: base);

    p{
      span{margin-left: space(m);}
    }

    &.bottom-border{
      @extend %border-bottom, %align-items-baseline;
      @include space-me($t:m, $b: m);
      margin-bottom: space(m);
    }
  }

  .data-entry__header{
    @include space-me($t: s, $b: m);
  }

  .transition-height{
    @include transition(height 0.3s cubic-bezier(.17,.67,.84,.71));
    height: 110px;

    &.minimize{
      height: 60px;
    }
  }

</style>
